import $ from '../utils/jquery';

const $section = $( '#state-stats' );
const $select = $section.find( '#state-select' );
const $wrapper = $section.find( '.results-wrapper' );
const $instructions = $section.find( '.select-instructions' );

const buildResultsList = ( results ) => {
	const $list = $( '<ul class="results-list"></ul>' );

	results.forEach( ( item ) => {
		const $item = $( '<li class="result-item"></li>' );
		$item.append( $( '<strong></strong>' ).text( item.val ) );
		$item.append( document.createTextNode( ' ' + item.title ) );
		$list.append( $item );
	} );

	return $list;
};

const showInstructions = () => {
	$wrapper.find( '.results-list' ).remove();
	$instructions.show();
};

const showResults = ( state ) => {
	$instructions.hide();
	$wrapper.find( '.results-list' ).remove();
	$wrapper.append( buildResultsList( state.results ) );
};

const bind = () => {
	$select.on( 'change', function() {
		const key = $( this ).val();
		const state = window.stateStats && window.stateStats[ key ];

		if ( ! key || ! state ) {
			showInstructions();
			return;
		}

		showResults( state );
	} );
};

export default () => {
	if ( ! $select.length ) {
		return;
	}

	bind();
};
